import { jsx as _jsx } from "react/jsx-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { HttpStatusCode } from 'axios';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { isRumExcludedPath } from '../../observability/privacyConfig';
import { useRumRouteGuard } from '../../observability/useRumRouteGuard';
import { CHALLENGE_STATUS } from '../../state/api';
import { FallbackComponent } from '../common';
import { ExpiredUser } from '../expired';
import { TermOfUse } from '../tou';
import { ErrorPage } from './errorPage';
import { useUserSessionAPI } from './selectors';
import { TerminologyProvider } from './terminology';
export var App = function () {
    var location = useLocation();
    var _a = useUserSessionAPI(), userSessionData = _a[0], fetchUserSessionData = _a[1];
    var _b = useState(''), challengeStatus = _b[0], setChallengeStatus = _b[1];
    useRumRouteGuard();
    useEffect(function () {
        fetchUserSessionData();
    }, [fetchUserSessionData]);
    useEffect(function () {
        if (!userSessionData.data)
            return;
        var _a = userSessionData.data, id = _a.id, orgs = _a.orgs;
        datadogRum.setUser({ id: String(id) });
        if (orgs[0]) {
            datadogRum.setAccount({ id: String(orgs[0].id) });
        }
        // Ensure a RUM view exists once the app is interactive (guards pre-start / missing-view cases).
        if (!isRumExcludedPath(location.pathname) && !datadogRum.getInternalContext()) {
            datadogRum.startView({ name: location.pathname });
        }
    }, [userSessionData.data, location.pathname]);
    useEffect(function () {
        window.addEventListener('storage', function (event) {
            if (event.key === CHALLENGE_STATUS && event.newValue) {
                setChallengeStatus(event.newValue);
                sessionStorage.removeItem(CHALLENGE_STATUS);
            }
        });
    }, []);
    useEffect(function () {
        if (userSessionData.requesting) {
            setChallengeStatus('');
        }
    }, [userSessionData.requesting]);
    if (challengeStatus === HttpStatusCode.Gone.toString())
        return _jsx(ExpiredUser, {});
    if (challengeStatus === HttpStatusCode.PreconditionFailed.toString())
        return _jsx(TermOfUse, {});
    if (userSessionData.error)
        return _jsx(ErrorPage, { error: userSessionData.error });
    if (!userSessionData.data)
        return _jsx(FallbackComponent, { requesting: true, overlay: true });
    return (
    // Valueless root provider: unscoped areas resolve terminology from the platform (org type)
    _jsx(TerminologyProvider, { children: _jsx(Outlet, {}) }));
};
